import styled from "@emotion/styled";

import { fontRoboto, fontRobotoCondensed, theme } from "shared/lib/styles";

export const Container = styled.div`
  display: none;
  ${theme.breakpoints.up("tablet")} {
    display: flex;
    flex-direction: row;
    gap: 16px;
    align-items: center;

    max-inline-size: 960px;
    padding: 20px;

    border: 1px solid #4585ff;
    border-radius: 12px;

    background: #ffffff;
  }
  ${theme.breakpoints.up("desktop")} {
    align-items: center;
  }
`;

export const ScmpPlusName = styled.span`
  font-weight: 700;
`;

export const Left = styled.div`
  inline-size: 100%;

  color: #4585ff;
  font-weight: 400;
  font-size: 16px;
  font-family: ${fontRobotoCondensed};
  line-height: 130%;
`;

export const CtaButton = styled.div`
  ${theme.breakpoints.up("tablet")} {
    gap: 8px;

    inline-size: 100%;
    padding-block: 8px;
    padding-inline: 12px;

    color: #ffffff;
    font-weight: 700;
    font-size: 16px;
    font-family: ${fontRobotoCondensed};
    line-height: 130%;
    white-space: nowrap;
    text-align: center;
    text-transform: uppercase;

    border: 2px solid #4585ff;
    border-radius: 2px;

    background-color: #4585ff;

    cursor: pointer;
    &:hover {
      text-decoration: underline;
    }
  }
`;

export const AlreadySubscriberWrapper = styled.div`
  display: flex;
  gap: 4px;
`;

export const AlreadySubscriberText = styled.div`
  color: #30343c;
  font-weight: 400;
  font-size: 12px;
  font-family: ${fontRoboto};
  font-style: normal;
  line-height: 100%;
  white-space: nowrap;
  text-align: center;
`;

export const LoginButton = styled.div`
  padding-block: 0;
  padding-inline: 2px 3px;

  color: #4585ff;
  font-weight: 700;
  font-size: 12px;
  font-family: ${fontRoboto};
  font-style: normal;
  line-height: 100%;
  white-space: nowrap;
  text-transform: uppercase;

  cursor: pointer;
`;

export const Right = styled.div`
  ${theme.breakpoints.up("tablet")} {
    display: flex;
    flex-direction: row;
    gap: 16px;
    align-items: center;
  }
`;
